import MODULE_NAME from './constants'

export const SET_PRIVACY = `${MODULE_NAME}/SET_PRIVACY`
export const setPrivacy = (privacy) => ({
  type: SET_PRIVACY,
  payload: { privacy },
})

export const SET_USER_PERMISSIONS = `${MODULE_NAME}/SET_USER_PERMISSIONS`
export const setUserPermissions = (permissions) => ({
  type: SET_USER_PERMISSIONS,
  payload: { permissions },
})
